export const percentCount = (percent) => {
  if (percent > 100) {
    return 100;
  }
  return percent;
};

export const getProgressText = (percent) => {
  if (percent <= 25) {
    return 'Let’s start!';
  }
  if (percent > 25 && percent <= 50) {
    return 'Doing great!';
  }
  if (percent > 50 && percent <= 75) {
    return 'Keep it up!';
  }
  if (percent > 75 && percent < 100) {
    return 'Almost there!';
  }
  if (percent >= 100) {
    return 'Congrats!';
  }
};
